/**
 * Where to go after signing in.
 *
 * Every email links to the page its action is on - a PTAE request, a claim, a
 * report. Signed out, that link used to land on /login, and Stanford sign-in
 * leaves the app entirely (to the IdP and back through /auth/callback), so the
 * page the email was about was forgotten and everyone ended up on the home page.
 * The path is kept in sessionStorage, which survives that round trip in the
 * same tab, and taken back once on return.
 */

const KEY = 'seed.returnPath';
// An abandoned sign-in should not send someone somewhere unexpected later on.
const MAX_AGE_MS = 30 * 60 * 1000;

/**
 * A path inside this app: one leading slash (not //host), no scheme or
 * backslash, and not one of the sign-in pages themselves.
 */
const isSafe = (path) => typeof path === 'string'
  && /^\/(?![/\\])/.test(path)
  && !path.includes('://')
  && !path.includes('\\')
  && !/^\/(login|signup|auth\/|complete-profile)(?:[/?#]|$)/.test(path);

export const rememberReturnPath = (path) => {
  if (!isSafe(path) || path === '/') return;
  try {
    sessionStorage.setItem(KEY, JSON.stringify({ path, at: Date.now() }));
  } catch { /* storage blocked: sign-in still works, it just lands on home */ }
};

/** The remembered path, once - it is cleared as it is read. */
export const takeReturnPath = () => {
  try {
    const raw = sessionStorage.getItem(KEY);
    sessionStorage.removeItem(KEY);
    if (!raw) return null;
    const { path, at } = JSON.parse(raw);
    return isSafe(path) && Date.now() - Number(at) < MAX_AGE_MS ? path : null;
  } catch {
    return null;
  }
};
